module.exports = __webpack_public_path__ + "img/blog-img-bg.2bf24cc3.png";